import router from "@/router";
import AgentQuickResponseService from "@/services/agent.quick.response.service";
import AppService from "@/services/app.service";
import {getField, updateField} from "vuex-map-fields";
import Vue from "vue";
import i18n from "@/plugins/i18n";

const state = () => ({
    showAgentQuickResponse: false,
    listResponseTemplate: [],
    listResponseTemplateLeader: [],
    loading: false,
    _id: "",
    title: "",
    content: "",
    type: 0,
    group: "",
    skillGroup: null,
    isLockReport: false,
    file: null,
});
const mutations = {
    setShowAgentQuickResponse(state, payload) {
        state.showAgentQuickResponse = payload
    },
    openLoading(state) {
        state.loading = true;
    },
    closeLoading(state) {
        state.loading = false;
    },
    setListResponseTemplate(state, payload) {
        state.listResponseTemplate = payload
    },
    setListResponseTemplateLeader(state, payload) {
        state.listResponseTemplateLeader = payload
    },
    updateAgentQuickResponse (state, data) {
        const idx = state.listResponseTemplate.findIndex(o => o._id === data._id)
        Vue.set(state.listResponseTemplate, idx, data)
    },
    updateAgentQuickResponseLeader (state, data) {
        const idx = state.listResponseTemplateLeader.findIndex(o => o._id === data._id)
        Vue.set(state.listResponseTemplateLeader, idx, data)
    },
    deleteAgentQuickResponse (state, data) {
        const idx = state.listResponseTemplate.findIndex(o => o._id === data._id)
        Vue.delete(state.listResponseTemplate, idx)
    },
    deleteAgentQuickResponseLeader (state, data) {
        const idx = state.listResponseTemplateLeader.findIndex(o => o._id === data._id)
        Vue.delete(state.listResponseTemplateLeader, idx)
    },
    createAgentQuickResponse(state, data) {
        state.listResponseTemplate.unshift(data)
    },
    createAgentQuickResponseLeader(state, data) {
        state.listResponseTemplateLeader.unshift(data)
    },
    setIsLockReport(state, data) {
        state.isLockReport = data
    },
    importAgentQuickResponse(state,data){
        state.listResponseTemplate = state.listResponseTemplate.concat(data)
    },
    importAgentQuickResponseLeader(state,data){
        state.listResponseTemplateLeader = state.listResponseTemplateLeader.concat(data)
    },
    bindFormData (state, data) {
        if (typeof data === 'object') {
            for (const propName in data) {
                state[propName] = data[propName]
                if(propName==='skillGroup'){
                    state[propName] = parseInt(data[propName])
                }
            }
        }
    },
    setType(state, data) {
        state.type = data
    },
    updateField
};
const actions = {
    bindUpdateForm({commit}, data) {
        commit('bindFormData', data)
    },
    exportAgentQuickResponse({}, data) {
        let botCode = router.currentRoute.params.bot_code ? router.currentRoute.params.bot_code : router.currentRoute.params.botCode;
        AgentQuickResponseService.export(botCode, data) .then((response) => {
            if (response.data && response.data.download_link){
                window.open(response.data.download_link, '_blank');
                AppService.toastSuccess(i18n.t("reportAgentQuickResponseSuccess"))
            }
            // context.commit('setIsLockReport', true)

        }).catch(()=> {
            AppService.toastError(i18n.t("reportFailed"));
        });
    },
    exportAgentQuickResponseLeader({}, data) {
        let botCode = router.currentRoute.params.bot_code ? router.currentRoute.params.bot_code : router.currentRoute.params.botCode;
        AgentQuickResponseService.export(botCode,data,true) .then((response) => {
            if (response.data && response.data.download_link){
                window.open(response.data.download_link);
                AppService.toastSuccess(i18n.t("reportAgentQuickResponseSuccess"))
            }
            // context.commit('setIsLockReport', true)
        }).catch(()=> {
            AppService.toastError(i18n.t("reportFailed"));
        });
    },
    unlockReport(context) {
        context.commit('setIsLockReport', false)
    },
    lockReport(context) {
        context.commit('setIsLockReport', true)
    },
    openAgentQuickResponse(context) {
        context.commit('setShowAgentQuickResponse', true)
    },
    closeAgentQuickResponse(context) {
        context.commit('setShowAgentQuickResponse', false)
    },
    toggleAgentQuickResponse(context) {
        context.commit('setShowAgentQuickResponse', !context.state.showAgentQuickResponse)
    },
    getAllAgentQuickResponse({commit}, _botCode) {
        let botCode = _botCode ? _botCode : router.currentRoute.params.bot_code;
        if (!botCode) {
            return;
        }
        commit('openLoading');
        AgentQuickResponseService.findAll(botCode)
            .then(res => {
                commit('setListResponseTemplate', res.data.results)
            })
            .finally(() => {
                commit("closeLoading")
            })
    },
    getAllAgentQuickResponseLeader({commit}, _botCode) {
        let botCode = _botCode ? _botCode : router.currentRoute.params.bot_code;
        commit('openLoading');
        AgentQuickResponseService.findAll(botCode, true)
            .then(res => {
                commit('setListResponseTemplateLeader', res.data.results)
            })
            .finally(() => {
                commit("closeLoading")
            })
    },
    saveAgentQuickResponse({dispatch, state, commit}) {
        dispatch('loading/openLoading', null, {root: true});
        let botCode = router.currentRoute.params.bot_code ? router.currentRoute.params.bot_code : router.currentRoute.params.botCode;
        let type = state.type
        let skillGroupCreate = state.skillGroup ? state.skillGroup : 0
        AgentQuickResponseService.create(botCode, state.title, state.content, type, skillGroupCreate)
            .then((res) => {
                if (type===0) {
                    commit('createAgentQuickResponse', res.data)
                }
                else commit('createAgentQuickResponseLeader', res.data)
                AppService.toastInfo(i18n.t('success'))
            })
            .catch(() => {
                AppService.toastError(i18n.t('failed'))
            })
            .finally(() => {
                dispatch('loading/closeLoading', null, {root: true});
                dispatch('dialog/closeDialogCreateQuickResponse', null, {root: true});
            })
    },
    updateQuickResponse({dispatch, state, commit}, type) {
        dispatch('loading/openLoading', null, {root: true});
        let botCode = router.currentRoute.params.bot_code ? router.currentRoute.params.bot_code : router.currentRoute.params.botCode;
        AgentQuickResponseService.update(botCode, state._id, state.title, state.content, type, state.skillGroup)
            .then((res) => {
                if (type === 0) {
                    commit('updateAgentQuickResponse', res.data)
                }
                else {
                    commit('updateAgentQuickResponseLeader', res.data)
                }
                AppService.toastInfo(i18n.t('success'))
            })
            .catch(() => {
                AppService.toastError(i18n.t('failed'))
            })
            .finally(() => {
                dispatch('loading/closeLoading', null, {root: true});
                dispatch('dialog/closeDialogCreateQuickResponse', null, {root: true});
            })
    },
    
    handleFileUpload({dispatch, state, commit}) {
        dispatch('loading/openLoading', null, {root: true});
        let botCode = router.currentRoute.params.bot_code ? router.currentRoute.params.bot_code : router.currentRoute.params.botCode;
        AgentQuickResponseService.uploadFile(botCode, state.file, state.type)
            .then((res) => {
                if(state.type === 0){
                    commit('importAgentQuickResponse', res.data.added_templates)
                }
                else{
                    commit('importAgentQuickResponseLeader', res.data.added_templates)
                   
                }
                
                if(res.data.errorLines.length > 0){
                    let message = `${i18n.t('numberOfErrorlines')}: ${res.data.errorLines.length}.`
                    message += ` ${i18n.t('errorLinePosition')}: ${res.data.errorLines}`
                    Vue.$confirm(
                        {
                            message: message,
                            button: {
                                yes: i18n.t('ok'),
                            },
                        },
                    )
                }

               
                AppService.toastInfo(i18n.t('success'))
                
            })
            .catch(() => {
                AppService.toastError(i18n.t('invalidFileContent'))
            })
            .finally(() => {
                dispatch('loading/closeLoading', null, {root: true});
                dispatch('dialog/closeDialogImportAgentQuickResponse', null, {root: true});
            })
    },

    deleteAgentQuickResponse({dispatch, commit}, data) {
        let botCode = router.currentRoute.params.bot_code ? router.currentRoute.params.bot_code : router.currentRoute.params.botCode;
        Vue.$confirm(
            {
                message: i18n.t('areYouSureDelete'),
                button: {
                    no: i18n.t('cancel'),
                    yes: i18n.t('ok'),
                },
                callback: confirm => {
                    if (confirm) {
                        dispatch('loading/openLoading', null, { root: true })
                        AgentQuickResponseService.deleteOne(botCode, data._id).then(res => {
                            commit('deleteAgentQuickResponse', res.data)
                            if (data.type===0) {
                                commit('deleteAgentQuickResponse', res.data)
                            }
                            else {
                                commit('deleteAgentQuickResponseLeader', res.data)
                            }
                            AppService.toastInfo(i18n.t('success'))
                        }).catch(() => {
                            AppService.toastError(i18n.t('failed'))
                        }).finally(() => {
                            dispatch('loading/closeLoading', null, { root: true })
                        })
                    }
                },
            },
        )
    },
    onUseTemplate(context, data) {
        AgentQuickResponseService.onUseTemplate(data.bot_code, data._id,data.sender_id, data.channel )
    }
};
const getters = {
    getField,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
